/** PaySDK expects CASH and CARD; used as fallback when no methods are specified */
export const PAYSDK_DEFAULT_ENABLED_PAYMENT_METHODS = ['CASH', 'CARD'];
export const PAYSDK_DEFAULT_DISABLED_CARD_TYPES = ['OVO Points'];

/** PaySDK screen types (maps to PaySDK.TYPES) */
export const PAYSDK_TYPES = {
  PAYMENT_LIST: 'PAYMENT_LIST',
  PAYMENT_RECOMMENDATION: 'PAYMENT_RECOMMENDATION',
};

/** PaySDK event names (from PaySDK script) */
export const PAYSDK_EVENTS = {
  PAYMENT_METHOD_SELECTED: 'payment_method_selected',
  CLICK_PAYMENT_RECOMMENDATION: 'click_payment_recommendation',
  PAYMENT_RECOMMENDATION_RECEIVED: 'payment_recommendation_received',
};

/** Event metadata keys for PaySDK events */
export const PAYSDK_EVENT_METADATA_KEYS = {
  PAYMENT_TYPE_ID: 'metadata.paymentTypeID',
  PAYMENT_METHOD_TYPE: 'metadata.paymentMethodType',
  SHORT_TITLE: 'metadata.shortTitle',
};

/** Enterprise profile types for PaySDK */
export const PAYSDK_PROFILE_TYPES = {
  CORPORATE: 'corporate',
  PERSONAL: 'personal',
};

/** PaySDK screen params (per spec) */
export const PAYSDK_PARTNER = 'express';
export const PAYSDK_SCREEN_TYPE = 'gaap';

/** Container ID prefixes for PaySDK mount points */
export const PAYSDK_CONTAINER_ID_PREFIXES = {
  PAYMENT_LIST: 'paysdk-payment-list',
  PAYMENT_RECOMMENDATION: 'paysdk-payment-recommendation',
};
export const PAYSDK_DEFAULT_CONTAINER_ID_PREFIX = 'paysdk';
